export default __webpack_public_path__ + "static/media/slide9.403ca0e2.png";